// gimme: conversations-inbox-ui 06/04/2020 c274e8ac5510b62b817eb74db200bc9802a2508d
'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WARNING_MODAL_WIDTH = 500;
export default class HardDeleteThreadPrompt extends Component {
  render() {
    const {
      onConfirm,
      onReject,
      ticket
    } = this.props;
    let deleteHeader;
    let deleteText;
    if (ticket) {
      deleteHeader = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.ticket-deletion.deletePrompt.heading"
      });
      deleteText = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.ticket-deletion.deletePrompt.body"
      });
    } else {
      deleteHeader = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-deletion.deletePrompt.heading"
      });
      deleteText = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-deletion.deletePrompt.body"
      });
    }
    return /*#__PURE__*/_jsxs(UIModal, {
      use: "danger",
      width: WARNING_MODAL_WIDTH,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onReject
        }), /*#__PURE__*/_jsx(H2, {
          children: deleteHeader
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: deleteText
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "danger",
          onClick: onConfirm,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-thread-view.thread-deletion.deletePrompt.confirm"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          onClick: onReject,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-thread-view.thread-deletion.deletePrompt.cancel"
          })
        })]
      })]
    });
  }
}
HardDeleteThreadPrompt.displayName = 'HardDeleteThreadPrompt';
HardDeleteThreadPrompt.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  ticket: PropTypes.object
};